<template>
<div class="chapter">
<div class="inner_page">
<div class="nobreak">
<p class="image"><img alt="Illustration" src="images/map1.png"/></p>
<p class="cap">This map shows only the coffin roads and graveyards featured in the numbered chapters and not those mentioned in the Introduction</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?2841c854